/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DayOfWeek } from './DayOfWeek';
import {
    DayOfWeekFromJSON,
    DayOfWeekFromJSONTyped,
    DayOfWeekToJSON,
    DayOfWeekToJSONTyped,
} from './DayOfWeek';
import type { MonthlyOrdinal } from './MonthlyOrdinal';
import {
    MonthlyOrdinalFromJSON,
    MonthlyOrdinalFromJSONTyped,
    MonthlyOrdinalToJSON,
    MonthlyOrdinalToJSONTyped,
} from './MonthlyOrdinal';
import type { CourtDayType } from './CourtDayType';
import {
    CourtDayTypeFromJSON,
    CourtDayTypeFromJSONTyped,
    CourtDayTypeToJSON,
    CourtDayTypeToJSONTyped,
} from './CourtDayType';

/**
 * 
 * @export
 * @interface CourtDayResponse
 */
export interface CourtDayResponse {
    /**
     * 
     * @type {CourtDayType}
     * @memberof CourtDayResponse
     */
    type: CourtDayType;
    /**
     * 
     * @type {DayOfWeek}
     * @memberof CourtDayResponse
     */
    weekday: DayOfWeek | null;
    /**
     * 
     * @type {MonthlyOrdinal}
     * @memberof CourtDayResponse
     */
    ordinal: MonthlyOrdinal | null;
    /**
     * 
     * @type {Array<Date>}
     * @memberof CourtDayResponse
     */
    dates: Array<Date>;
}



/**
 * Check if a given object implements the CourtDayResponse interface.
 */
export function instanceOfCourtDayResponse(value: object): value is CourtDayResponse {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('weekday' in value) || value['weekday'] === undefined) return false;
    if (!('ordinal' in value) || value['ordinal'] === undefined) return false;
    if (!('dates' in value) || value['dates'] === undefined) return false;
    return true;
}

export function CourtDayResponseFromJSON(json: any): CourtDayResponse {
    return CourtDayResponseFromJSONTyped(json, false);
}

export function CourtDayResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourtDayResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'type': CourtDayTypeFromJSON(json['type']),
        'weekday': DayOfWeekFromJSON(json['weekday']),
        'ordinal': MonthlyOrdinalFromJSON(json['ordinal']),
        'dates': (json['dates'] as Array<any>).map((el: any) => new Date(el)),
    };
}

export function CourtDayResponseToJSON(json: any): CourtDayResponse {
    return CourtDayResponseToJSONTyped(json, false);
}

export function CourtDayResponseToJSONTyped(value?: CourtDayResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': CourtDayTypeToJSON(value['type']),
        'weekday': DayOfWeekToJSON(value['weekday']),
        'ordinal': MonthlyOrdinalToJSON(value['ordinal']),
        'dates': (value['dates'] as Array<Date>).map((el) => `${el.getFullYear()}-${String(el.getMonth()+1).padStart(2,'0')}-${String(el.getDate()).padStart(2,'0')}`),
    };
}

